import { TPVServices } from './../tpv/services';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Subject } from 'rxjs';
import { Globals } from "../../globals";
import { StockServices } from "../stock/services";
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, LoadingController } from 'ionic-angular';
import { ConfigurationServices } from '../configuration/services';
import { HttpClient } from '@angular/common/http';
import { AnalyticsServices } from '../services/analyticsServices';
import { getCurrencySymbol } from '@angular/common';

interface Room {
    UID: string;
}

interface Table {
    UID: string;
    name: string;
    ticket: any;
    cash_static: any;
    cash_uid: any;
    type: string;
    discount_type: string;
    discount_value: number;
    datetime_pickup_delivey: any;
    //order:any;
}

interface Menu {
    UID: string;
}

interface Dish {
    UID: string;
    tags: any;
}

interface Product {
    UID: string;
    tags: any;
}

interface Ticket {
    UID: string;
    number: any;
    cash_uid: any;
}

interface Cash {
    UID: string;
    name: string;
    number: any;
}

interface Order {
    UID: string;
    UID_RESTAURANT: string;
    hour: string;
    sections: any;
    show_kitchen: boolean;
    table: string;
    type: string;
    waiter: string;
    waiter_uid: string;
}

@Injectable()
export class TakeawayServices {
    //TMP
    public menu_select_room = 'take_away';
    public section_select = 'Menu';
    public menu_select = '';
    public section_order = this.translate.instant('general-todos');
    public section_menu_order = 'Primeros';
    public selected_type: any;
    public firestore: any;
    public ticket_uid: any;
    public order_tmp: any = [];
    public listall_print: any = [];
    public listchange_print: any = [];
    public selected_list: any;
    public quick_create: boolean = false;
    public print_type: boolean = true;
    public is_combo: any;
    public selectedPersonId: string;
    public selected_tag: any;

    public customer: any;
    public deliveries = [{
        'name': 'Uber Eats',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_Uber-eats.svg?alt=media&token=8f638d9b-baf1-4fa8-a009-14bedb075971',
        'active': false,
        'favorites_UID': undefined,
        'UID': undefined,
    }, {
        'name': 'Deliveroo',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_Deliveroo.svg?alt=media&token=afa7aad9-3f1e-4cc9-880b-1517617e5a9c',
    }, {
        'name': 'Takeaway.com',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_takeaway.svg?alt=media&token=52472724-c943-4a5e-9920-b6b9129cdbd8',
    }, {
        'name': 'Glovo',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_GLOVO.svg?alt=media&token=32e9367e-7061-4228-97ab-8dee5b148994'
    }, {
        'name': 'Foodora',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_fOODORA.svg?alt=media&token=4b710aac-c223-4805-b0e7-a7e99c2368cc'
    }, {
        'name': 'DoorDash',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDoordash.webp?alt=media&token=0bc03c7e-8ae1-4ce9-9e6e-e17877a130f5'
    }, {
        'name': 'Just Eat',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_just-eat.svg?alt=media&token=63d88b7a-1eb9-442c-ba8b-9b98d46c3f7e'
    }, {
        'name': 'Delivery Hero',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_dELIVERY-hERO.svg?alt=media&token=dff2271a-3523-45e8-9506-617c999e5f07'
    }, {
        'name': 'Wolt',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FWolt_logo_RGB_blue.jpg?alt=media&token=fdaba6b9-b33b-4320-85d1-62e4a87823d8'
    }, {
        'name': 'Lieferando.de',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-integration_lieferando-integration-copy.svg?alt=media&token=8254e397-e680-4b3a-bc05-4e8b033d8eb1'
    }, {
        'name': 'Pizza.de',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_pizza.de_.png?alt=media&token=0ea08462-37b0-405e-9a97-22a047056b5c'
    }, {
        'name': 'Pizza-online.fi',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_pizza-online-fi.svg?alt=media&token=6c131241-9cea-4528-96a8-bb0e5840d9ad'
    }, {
        'name': 'Talabat',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_Talabat12.svg?alt=media&token=9bec810f-70e3-432e-8815-17640d4dac6c'
    }, {
        'name': 'Carriage',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_Trycarriage-carriage-food-delivery-logo.svg?alt=media&token=7d671704-19e9-4252-af9d-826f8c5e7982'
    }, {
        'name': 'OnlinePizza',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logos_Onlinepizza.svg?alt=media&token=ce66f39b-8fec-4b90-975c-15002debee91'
    }, {
        'name': 'Tring Tring',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FTringTring_logo_blue.svg?alt=media&token=33903390-f02e-4d0f-b16e-fab0989f6689'
    }, {
        'name': 'MyDelivery',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FMyDelivery.webp?alt=media&token=db287be7-2239-4e6b-a181-829dc4429640'
    }, {
        'name': 'Zomato',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery%20logos_zomato%20integration.svg?alt=media&token=b3fa3916-0baa-4532-be57-987452bfebdd'
    }, {
        'name': 'Postmates',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDeliverey-postmates.png?alt=media&token=c953087d-fb55-42cd-a0cd-2c46e9420609'
    }, {
        'name': 'Ritual',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-Ritual_160wide-01.svg?alt=media&token=777114be-48bc-456e-b894-518cb8e51b13'
    }, {
        'name': 'Karma',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-karma.png?alt=media&token=381e08f5-7a34-46d4-be57-62b6d380f6f8'
    }, {
        'name': 'Take away',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2Ftakeaway.png?alt=media&token=2d6ae57c-84d1-4b0a-b1c2-2bc7b4a39b12'
    }, {
        'name': 'Domicilio',
        'img': ''
    }, {
        'name': 'Recogida',
        'img': ''
    }, {
        'name': 'eCommerce',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2Fdelivery-logo-ecommerce.svg?alt=media&token=82f8a678-3056-4980-934b-3edf0ad62c88'
    }, {
        'name': 'Flipdish',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2Fdelivery-logo-flipidish.svg?alt=media&token=83a5749b-7c26-46c1-955e-7cf22e1fe382'
    }, {
        'name': 'iFood',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2Fdelivery-logo-ifood.svg?alt=media&token=b8b329f4-5528-4557-a2ff-12ce34bc1cb8'
    }, {
        'name': 'Rappi',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2Fdelivery-logo-rappi.svg?alt=media&token=f20d3687-82f9-43d2-bee0-988bf7b81a61'
    }, {
        'name': 'PedidosYa',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2Fdelivery-logo-pedidosya.svg?alt=media&token=a4327c44-edf5-47e1-bbf8-cb25f9d892ce'
    }, {
        'name': 'SinDelantal',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2Fdelivery-logo-sindelantal.svg?alt=media&token=ed7ae0db-c014-466d-b8a3-8281a6f2e75e'
    }, {
        'name': 'Bold',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-Bolt-Food_Logo-Vertical_RGB.png?alt=media&token=c71ec344-09bd-4167-98cc-5476b82a5dc3'
    }, {
        'name': 'Caviar',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-caviar_logo.png?alt=media&token=eebf9d30-6e17-4904-8b42-8a9eb2f72542'
    }, {
        'name': 'Curbside Ninja',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-logo-curbside.png?alt=media&token=012a81c0-db43-42a8-828b-a257823bb420'
    }, {
        'name': 'Eat.ch',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-eatch.png?alt=media&token=1f71edd3-b979-4cf0-b892-bd1c160fcaea'
    }, {
        'name': 'Jahez',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-jahez.png?alt=media&token=c448159e-7b9c-4322-aaaa-d42d94a2172a'
    }, {
        'name': 'Lieferando',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-integration_lieferando-integration-copy.svg?alt=media&token=8254e397-e680-4b3a-bc05-4e8b033d8eb1'
    }, {
        'name': 'Mealeo',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-mealeo_man.png?alt=media&token=96b08038-8ac8-45a9-8703-b69af0ad474b'
    }, {
        'name': 'MenuLog',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-Menulog_logo-01.svg?alt=media&token=642047ed-c326-4cb8-842a-f6de020a5e4c'
    }, {
        'name': 'SkipTheDishes',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDeliverey-SkipTheDishes.png?alt=media&token=1440b816-c41d-4d35-acac-c5b4983acadd'
    }, {
        'name': 'Smood',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-smood_logo.png?alt=media&token=2361142e-9d29-4968-b958-735b8f9d2837'
    }, {
        'name': 'Thuisbezorgd',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDeliverey-thuisbezorgd.png?alt=media&token=432cbc0b-a4df-4929-8fd5-df0919a0dffd'
    }, {
        'name': 'iZiFood',
        'img': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/deliveries%2FDelivery-izifood.png?alt=media&token=09bb8a39-6022-418d-a973-a662d5fb33c2'
    }
    ];

    //
    update_state: boolean = false;
    element: any;
    i: any;
    j: any;
    orders_print: string = 'all';

    public config_horary = true;
    horary_array = [];
    public old_orders = [];
    public alert_old_orders: boolean = false;
    is_girona: boolean = false;
    table_takeaway_term: string = "";

    constructor(public afs: AngularFirestore,
        public globals: Globals,
        public stockServices: StockServices,
        public translate: TranslateService,
        public tpvServices: TPVServices,
        public alertCtrl: AlertController,
        public configurationServices: ConfigurationServices,
        public http: HttpClient,
        public analyticsServices: AnalyticsServices,
        public loadingCtrl: LoadingController) {
        this.firestore = firebase.firestore();
    }

    //Rooms
    roomsCol: AngularFirestoreCollection<Room>;
    rooms: Observable<Room[]>;
    roomsDoc: AngularFirestoreDocument<Room>;
    room: any;
    room_selected_uid: any;
    room_selected_name: any;

    getRooms(UID_RESTAURANT) {
        this.roomsCol = this.afs.collection('rooms', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT));
        this.rooms = this.roomsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Room;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

    //Tables
    tablesCol: AngularFirestoreCollection<Table>;
    tables: Observable<Table[]>;
    tables_takeaway: Observable<Table[]>;
    tables_array: any;
    public table_tmp: Table;
    tablesDoc: AngularFirestoreDocument<Table>;
    table: any;
    selected_table_tpv: any;
    selected_table_tpv_index: any;
    table_bar_index: any;
    tables_array_take_away = [];
    selected_table_uid: any;
    tables_array_tk_kitchen: any;
    getTables(UID_RESTAURANT) {
        this.tablesCol = this.afs.collection('tables', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT));
        this.tables = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                return data;
            });
        });

        this.tablesCol.snapshotChanges().subscribe(value => {
            this.tables_array_tk_kitchen = [];
            value.map((a, index) => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                this.tables_array_tk_kitchen.push(data);
                //Anadimos el index de la tabla bar para poder utilizarlo.
                if (data.type == 'bar') {
                    this.table_bar_index = index;
                }
                return data;
            });

        });
    }

    checkChangesTables(UID_RESTAURANT) {
        this.tablesCol = this.afs.collection('tables', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('type', '<', 'takeaway'));
        this.tables = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                return data;
            });
        });

        this.tablesCol.snapshotChanges().subscribe(value => {
            value.map((a, index) => {

            });
            this.getHorary();
        });
    }

    getTablesTakeaway(UID_RESTAURANT) {
        this.tablesCol = this.afs.collection('tables', ref => ref
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('type', '==', 'takeaway')
            .orderBy('datetime_pickup_delivey', 'desc')
            .orderBy('created_at', 'desc'));
        this.tables_takeaway = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                this.checkDeliverectCancelled(data);
                return data;
            });
        });

        this.tablesCol.snapshotChanges().subscribe(async value => {
            this.tables_array = [];
            value.map((a, index) => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                this.tables_array.push(data);
                //Anadimos el index de la tabla bar para poder utilizarlo.

                return data;
            });
            this.getHorary();
            this.checkOldOrders();
            //await this.getIndexByTableuid();
            //
            this.checkIfTablePaid();
        });
    }

    /*getAscTablesTakeaway(UID_RESTAURANT) {
        this.tablesCol = this.afs.collection('tables', ref => ref
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('type', '==', 'takeaway')
            .orderBy('datetime_pickup_delivey', 'asc')
            .orderBy('created_at', 'desc'));
        this.tables_takeaway = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                return data;
            });
        });

        this.tablesCol.snapshotChanges().subscribe(value => {
            this.tables_array = [];
            value.map((a, index) => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                this.tables_array.push(data);
                //Anadimos el index de la tabla bar para poder utilizarlo.

                return data;
            });

        });
    }*/
    /*
        getTablesRoom(UID_RESTAURANT, room_uid) {
            this.tablesCol = this.afs.collection('tables', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('uid_room', '==', room_uid));
            this.tables = this.tablesCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Table;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
        }*/

    async getTable(table_uid) {
        const cashRef = this.firestore.collection('tables').doc(table_uid);

        var table;

        await
            cashRef.get().then(doc => {
                table = doc.data();
                table.UID = doc.id;
            });

        return table
    }

    async getTakeawayIndex(UID_RESTAURANT) {
        const ordersRef = this.firestore.collection('tables');

        var orders = [];

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('type', '==', 'takeaway')
            .orderBy('created_at', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var order = doc.data();
                    order.UID = doc.id;

                    orders.push(order);
                });
            });

        return orders
    }


    calculateTip(tip_number, total) {
        var tip = 0;

        if (tip_number === 1) {
            tip = (total * this.globals.restaurant.tip_1) / 100;
        } else if (tip_number === 2) {
            tip = (total * this.globals.restaurant.tip_2) / 100;
        } else {
            tip = (total * this.globals.restaurant.tip_3) / 100;
        }

        return tip;
    }


    //Limpiamos array para subir a firebase
    cleanTicketArray() {
        for (let key in this.table_tmp.ticket.list) {
            delete this.table_tmp.ticket.list[key].variation_array;
            delete this.table_tmp.ticket.list[key].variation_add;
        }
    }

    //Creamos temporal de variacions del plato
    variations_tmp = Array();

    //Inserta un elemento en una mesa
    insertTable(_name, _price, _delete, _count, _type, _uid, sec, _element) {
        //check price
        if (_price == undefined) {
            _price = 0;
        }
        //check tags
        if (_element.tags == undefined) {
            _element.tags = [];
        }
        //check type_unit
        if (_element.type_unit == undefined) {
            _element.type_unit = "ud";
        }
        //check tax
        if (_element.tax == undefined) {
            _element.tax = parseFloat(this.globals.user_tax);
        }
        //create object
        var obj = {
            count: _count,
            delete: _delete,
            name: _name,
            price: _price,
            tax: _element.tax,
            type: _type,
            uid_element: _uid,
            units: 1,
            change: '',
            finish: '',
            state: 'normal',
            variations: [],
            tags: _element.tags,
            type_unit: _element.type_unit
        }
        //case scale add units 1
        if (_element.type_unit === 'scale') {
            obj.units = 1;
        }
        //modificacio
        var section = {};
        if (this.update_state) {
            if (Object.keys(this.order_tmp).length == 0) {
                section = {
                    name: sec,
                    list: {
                        0: obj,
                    },
                }
                this.order_tmp.push(section);

            }
        } else {
            var index = this.order_tmp.findIndex(x => x.name == sec);

            if (index >= 0) {
                //this.order_tmp[index].list.push(list);
                var last_key = Object.keys(this.order_tmp[index].list)[Object.keys(this.order_tmp[index].list).length - 1]; //get the last key in the object
                if (last_key == undefined) {
                    last_key = '0';//Iniciamos a 0 si esta undefined
                }
                this.order_tmp[index].list[Number(last_key) + 1] = obj;

            } else {
                section = {
                    name: sec,
                    list: {
                        0: obj,
                    },
                }
                this.order_tmp.push(section);

            }
        }
        //data set waiter activity
        var extra_activity: any =
        {
            'type': 'add',
            'value': 1,
            'source': 'takeaway',

        };
        this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
    }

    one_time: any;
    async insertTableDiscount(_name, _price, _delete, _count, _type, _uid, discount_type, discount_value, rest_tax) {
        var _name = _name;
        var _price = _price;
        var _delete = _delete;
        var _count = _count;
        var _type = _type;
        var _uid = _uid;
        var _rest_tax = rest_tax;
        //
        await this.getIndexByTableuid();
        //
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Eliminamos el camp variation array para poder hacer el update
        this.cleanTicketArray();

        var last_key = Object.keys(this.table_tmp.ticket.list)[Object.keys(this.table_tmp.ticket.list).length - 1]; //get the last key in the object
        if (last_key == undefined) {
            last_key = '0';//Iniciamos a 0 si esta undefined
        }
        //check tax
        if (_rest_tax == undefined) {
            _rest_tax = parseFloat(this.globals.user_tax);
        }
        //
        this.table_tmp.ticket.list[Number(last_key) + 1] = {//Creamos objeto del nuevo plato
            name: _name,
            price: _price,
            delete: _delete,
            count: _count,
            type: _type,
            uid_element: _uid,
            waiter: this.globals.waiter,
            waiter_uid: this.globals.waiter_uid,
            units: 1,
            tax: _rest_tax,
            tags: []
        };

        if (this.table_tmp.discount_value) {
            this.table_tmp.discount_value += discount_value;
        } else {
            this.table_tmp.discount_value = discount_value;
        }

        if (this.table_tmp.discount_value) {
            this.table_tmp.discount_value += discount_value;
        } else {
            this.table_tmp.discount_value = discount_value;
        }

        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: this.table_tmp.ticket.number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: new Date(),
                tip: this.checkTip(this.table_tmp.ticket.tip),
                delivery: this.table_tmp.ticket.delivery,
                order_state: this.globals.ifVarEmpty(this.table_tmp.ticket.order_state),
            },
            discount_type: discount_type,
            discount_value: this.table_tmp.discount_value
        }).then(doc => {
            //data set waiter activity
            var extra_activity: any =
            {
                'type': 'discount',
                'value': 1,
                'source': 'takeaway',

            };
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
        });

    }

    //Inserta un elemento con variaciones en una mesa
    insertTableWithVariation(_name, _price, _delete, _count, _type, _uid, units, sec, _element) {
        for (var i = 0; i < units; i++) {
            //check price
            if (_price == undefined) {
                _price = 0;
            }
            //check tags
            if (_element.tags == undefined) {
                _element.tags = [];
            }
            //check type_unit
            if (_element.type_unit == undefined) {
                _element.type_unit = "ud";
            }
            //check tax
            if (_element.tax == undefined) {
                _element.tax = parseFloat(this.globals.user_tax);
            }
            //create object
            var obj = {
                count: _count,
                delete: _delete,
                name: _name,
                price: _price,
                tax: _element.tax,
                type: _type,
                uid_element: _uid,
                units: units,
                change: '',
                finish: '',
                state: 'normal',
                variations: this.variations_tmp,
                tags: _element.tags,
                type_unit: _element.type_unit
            }
            //case scale add units 1
            if (_element.type_unit === 'scale') {
                obj.units = 1;
            }
            var section = {};
            if (this.update_state) {
                if (Object.keys(this.order_tmp).length == 0) {
                    section = {
                        name: sec,
                        list: {
                            0: obj,
                        },
                    }
                    this.order_tmp.push(section);

                }
            } else {
                var index = this.order_tmp.findIndex(x => x.name == sec);

                if (index >= 0) {
                    //this.order_tmp[index].list.push(list);
                    var last_key = Object.keys(this.order_tmp[index].list)[Object.keys(this.order_tmp[index].list).length - 1]; //get the last key in the object
                    if (last_key == undefined) {
                        last_key = '0';//Iniciamos a 0 si esta undefined
                    }

                    this.order_tmp[index].list[Number(last_key) + 1] = obj;

                } else {
                    section = {
                        name: sec,
                        list: {
                            0: obj,
                        },
                    }
                    this.order_tmp.push(section);

                }

                //this.variations_tmp = [];
            }
            //data set waiter activity
            var extra_activity: any =
            {
                'type': 'add',
                'value': 1,
                'source': 'takeaway',

            };
        }
        this.variations_tmp = [];
        this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');

    }

    //Elimina un elemento de una mesa
    async deleteTableList(valueSearch) {
        //
        await this.getIndexByTableuid();
        //
        this.table_tmp = this.tables_array[this.selected_table_tpv_index];

        for (let key in this.table_tmp.ticket.list) {
            delete this.table_tmp.ticket.list[key].variation_array;
            if (this.table_tmp.discount_value > 0) {
                delete this.table_tmp.ticket.list[key].state_indv;
            }
        }
        var discount_type = '';
        var discount_value = 0;

        //Eliminamos los elementos segun su valor de la key en el objeto. Borrara todas las unidades
        while (Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch)) {
            if (this.table_tmp.ticket.list[Number(Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch))].price < 0) {
                discount_type = '';
                discount_value = 0;
            } else {
                discount_type = this.table_tmp.discount_type;
                discount_value = this.table_tmp.discount_value;
            }
            delete this.table_tmp.ticket.list[Number(Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch))];
        }

        if (this.table_tmp.discount_type == undefined) {
            discount_type = '';
            discount_value = 0;
        }

        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: this.table_tmp.ticket.number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: new Date(),
                tip: this.checkTip(this.table_tmp.ticket.tip),
                delivery: this.table_tmp.ticket.delivery,
                order_state: this.globals.ifVarEmpty(this.table_tmp.ticket.order_state),
            },
            discount_type: discount_type,
            discount_value: discount_value
        }).then(doc => {
            //data set waiter activity
            var extra_activity: any =
            {
                'type': 'remove',
                'value': 1,
                'source': 'takeaway',

            };
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
        });
        //
        await this.getIndexByTableuid();
        //
        this.selected_list = this.listSelectedTicket('name', this.globals.objectToArray(this.tables_array[this.selected_table_tpv_index].ticket.list))

    }

    cleanTicketIndvSelectedArrayInvite() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        for (let key in this.table_tmp.ticket.list) {
            if (this.table_tmp.ticket.list[key].state_indv === 'selected') {
                this.updateTableNumberInvite(this.table_tmp.ticket.number);
            }
        }
    }

    async updateTableNumberInvite(number) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        //Actualizamos la tabla de la base de datos
        await this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: new Date(),
                number: number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: this.table_tmp.ticket.updated_at,
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            state: 'close'
        });

    }

    //Precio total de les elementos del ticket
    totalOrderSelected() {
        var total = 0;
        for (let order of this.order_tmp) {
            for (let list of this.globals.objectToArray(order.list)) {
                total += parseFloat(list.price); //Sumamos el precio del plato
                for (let variation of this.globals.objectToArray(list.variations)) {
                    total += parseFloat(variation.price);
                }
            }

        }
        return total;
    }

    //Precio total ticket sin impuestos
    totalOrderSelectedNoTax(tax) {
        var total = this.totalOrderSelected();
        var sub = total / ((tax + 100) / 100);
        return sub;
    }

    public tip_ticket_indv_print = 0;
    //Precio total de les elementos del ticket
    totalTicketSelected(index) {
        //total
        var total = 0;
        var _taxs = this.globals.showIvaProducts(this.tables_array[index].ticket.list);
        total += _taxs.total;
        //tip
        if (this.tables_array[index].ticket.tip) {
            total += parseFloat(this.tables_array[index].ticket.tip);
        }
        return total;
    }

    totalTicketSelectedT(table) {
        //total
        var total = 0;
        var _taxs = this.globals.showIvaProducts(table.ticket.list);
        total += _taxs.total;
        //tip
        if (table.ticket.tip) {
            total += parseFloat(table.ticket.tip);
        }
        return total;
    }

    totalTicketSelectedNoTax(index, tax) {
        var _taxs = this.globals.showIvaProducts(this.tables_array[index].ticket.list);
        return _taxs.subtotal;
    }

    totalNumElements(ticket) {
        var total = 0;

        for (let element of this.globals.objectToArray(ticket.list)) {
            if (element.count == true) {
                total++;
            }
        }

        return total;

    }



    //Lista de elementos selecionados en una mesa
    listSelectedTicket(propertyName, inputArray) {
        //Inicializamnos los arrays
        var array_return = Array();
        var array_count = Array();
        var array_count_return = Array();
        var array_nocount = Array();
        var array_nocount_return = Array();
        var array_delete = Array();
        var array_delete_return = Array();


        //Separamos los valores del array conjunto por los array del coun, no count i delete
        inputArray.map(function (item) {
            if (item.count && !item.delete) {
                //count true
                array_count.push(item);
            } else if (!item.count && !item.delete) {
                //count false
                array_nocount.push(item);
            } else if (item.delete) {
                //Delete true
                array_delete.push(item);
            }
        });

        //Count
        array_count.map(function (item) {
            //Duplicate item
            if (item.type_unit != 'scale') {
                item.units = 0;// Iniciamos las unidades
            }
            item.variation_array = Array();

            //Buscamos los elementos por uid_element, si no por name
            var itemPropertyName = item['name'];
            var itemPropertyPrice = item['price'];
            if (itemPropertyName in array_count && item.type_unit != 'scale') {
                if (itemPropertyPrice === array_count[itemPropertyName].price) {//miramos si precio es diferentep
                    array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    if (item.variation) {//Comprovamos si tiene variaciones
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_count[itemPropertyName].variation_add += parseFloat(value.price);
                        }
                    }
                    item.duplicate = true;//Marcamos item como duplicado
                } else {//caso precio diferente volvemos a inicializar sus datos
                    array_count[itemPropertyName] = item;
                    if (item.type_unit != 'scale') {
                        array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    }
                    array_count[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                    if (item.variation) {//Comprovamos si tiene variaciones

                        //Add variation
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_count[itemPropertyName].variation_add += parseFloat(value.price);
                        }

                    }
                }
            } else {
                array_count[itemPropertyName] = item;
                if (item.type_unit != 'scale') {
                    array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                }
                array_count[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones

                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_count[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_count.forEach(value => {
            if (value.duplicate != true) {
                array_count_return.push(value);
            }
        });

        //No Count
        array_nocount.map(function (item) {
            //Duplicate item
            if (item.type_unit != 'scale') {
                item.units = 0;// Iniciamos las unidades
            }
            item.variation_array = Array();
            var itemPropertyName = item[propertyName];
            var itemPropertyPrice = item['price'];

            if (itemPropertyName in array_nocount && item.type_unit != 'scale') {
                if (itemPropertyPrice === array_nocount[itemPropertyName].price) {//miramos si precio es diferentep
                    array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    if (item.variation) {//Comprovamos si tiene variaciones
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                        }
                    }
                    item.duplicate = true;//Marcamos item como duplicado
                } else {//caso precio diferente volvemos a inicializar sus datos
                    array_nocount[itemPropertyName] = item;
                    if (item.type_unit != 'scale') {
                        array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    }
                    array_nocount[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                    if (item.variation) {//Comprovamos si tiene variaciones
                        array_nocount[itemPropertyName].variation_array = Array();
                        //Add variation
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                        }

                    }
                }

            } else {
                array_nocount[itemPropertyName] = item;
                if (item.type_unit != 'scale') {
                    array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                }
                array_nocount[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones
                    array_nocount[itemPropertyName].variation_array = Array();
                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_nocount.forEach(value => {
            if (value.duplicate != true) {
                array_nocount_return.push(value);
            }
        });

        //Delete
        array_delete.map(function (item) {
            //Duplicate item
            if (item.type_unit != 'scale') {
                item.units = 0;// Iniciamos las unidades
            }
            item.variation_array = Array();
            var itemPropertyName = item[propertyName];
            var itemPropertyPrice = item['price'];

            if (itemPropertyName in array_delete) {
                if (itemPropertyPrice === array_delete[itemPropertyName].price && item.type_unit != 'scale') {//miramos si precio es diferentep
                    array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    if (item.variation) {//Comprovamos si tiene variaciones
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                        }
                    }
                    item.duplicate = true;//Marcamos item como duplicado
                } else {//caso precio diferente volvemos a inicializar sus datos
                    array_delete[itemPropertyName] = item;
                    if (item.type_unit != 'scale') {
                        array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    }
                    array_delete[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                    if (item.variation) {//Comprovamos si tiene variaciones
                        array_delete[itemPropertyName].variation_array = Array();
                        //Add variation
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                        }

                    }
                }
            } else {
                array_delete[itemPropertyName] = item;
                if (item.type_unit != 'scale') {
                    array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                }
                array_delete[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones
                    array_delete[itemPropertyName].variation_array = Array();
                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_delete.forEach(value => {
            if (value.duplicate != true) {
                array_delete_return.push(value);
            }
        });

        array_return.push(array_count_return);
        array_return.push(array_nocount_return);
        array_return.push(array_delete_return);

        return array_return;//Devolvemos array con las cantidades agrupadas
    }

    //Actualiza el numoer de comensales
    tableUpdatePersons(persons) {
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            persons: persons,
        });
    }

    //Elimina todos los elementos del ticket
    cancelTicket() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: '',
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: {},
                tip: 0,
            },
            state: 'open'
        });
    }

    //update table per el cambrer quan entra
    updateSelectTableWaiter() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                waiter: this.tables_array[this.selected_table_tpv_index].ticket.waiter,
                waiter_uid: this.tables_array[this.selected_table_tpv_index].ticket.waiter_uid,
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: '',
                list: {},
                tip: this.checkTip(this.table_tmp.ticket.tip),
            }
        });
    }



    public total_ticket_indv_print = 0;
    public subtotal_ticket_indv_print = 0;

    totalTicketIndv(elements) {//Total del ticket individual
        var total = 0;
        for (let key in elements) {
            let value = elements[key];
            if (value.state_indv == 'selected') {
                total += value.price;
                for (let key_var in value.variation) {
                    total += value.variation[key_var].price;
                }
            }
        }
        this.total_ticket_indv_print = total;
        return total;
    }

    totalTicketIndvNoTax(elements, tax) {//Total del ticket individual no tax
        var total = this.totalTicketIndv(elements);
        //var sub =  total - (total * tax / 100);
        var sub = total / ((tax + 100) / 100);
        this.subtotal_ticket_indv_print = sub;
        return sub;
    }

    totalTicketIndvElementPrice(element) {//Total de un elemento individual del ticket indv
        var total = 0;
        total += Number(element.price);
        for (let key_var in element.variation) {
            total += Number(element.variation[key_var].price);
        }
        return total;
    }


    cleanTicketIndvSelectedArray() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        for (let key in this.table_tmp.ticket.list) {
            if (this.table_tmp.ticket.list[key].state_indv === 'selected') {
                this.table_tmp.ticket.list[key].state_indv = 'pay';
                this.updateTableNumber(this.table_tmp.ticket.number);
            }
        }
    }

    async updateTableNumber(number) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        await this.cleanTicketArray();

        var _date = new Date();
        this.tables_array[this.selected_table_tpv_index].ticket.date = _date;
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: _date,
                number: number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: _date,
                list: this.table_tmp.ticket.list,
                tip: this.checkTip(this.table_tmp.ticket.tip),
                delivery: this.table_tmp.ticket.delivery,
                order_state: this.globals.ifVarEmpty(this.table_tmp.ticket.order_state),
            },
            state: 'ticket'
        });

    }

    tableUpdateCash(cash) {//funcion que actuliza la caja del ticket de la table
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            cash_static: cash.name,
            cash_uid: cash.UID,
        });
    }


    async cashTicketPay(payment_type, type) {
        //getIndexByTableuid
        await this.getIndexByTableuid();
        //recuperar mesa
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //dataset de elements venuts
        for (let element of this.globals.objectToArray(this.table_tmp.ticket.list)) {
            if (element.type == 'menu' || element.type == 'combo') {
                this.globals.dataSet('sales_menu', element.name, '', element.price, '');
            } else if (element.type == 'dish') {
                this.globals.dataSet('sales_dish', element.name, '', element.price, '');
            } else if (element.type == 'product') {
                this.globals.dataSet('sales_product', element.name, '', element.price, '');
            }
        }
        //Eliminamos el camp variation array para poder hacer el update
        await this.cleanTicketArray();
        //get ticket number
        await this.getTicketNumber(this.globals.restaurant_uid, this.table_tmp.cash_uid);
        //getIndexByTableuid
        await this.getIndexByTableuid();
        //
        this.table_tmp = this.tables_array[this.selected_table_tpv_index];

        this.tables_array[this.selected_table_tpv_index].ticket.amount = this.totalTicketSelected(this.selected_table_tpv_index);
        this.tables_array[this.selected_table_tpv_index].ticket.number = this.ticket_num_return;
        this.tables_array[this.selected_table_tpv_index].ticket.payment = true;
        this.tables_array[this.selected_table_tpv_index].ticket.payment_type = payment_type;
        this.tables_array[this.selected_table_tpv_index].ticket.delivery = this.selected_table_tpv.ticket.delivery;
        //comprovar discount
        if (this.table_tmp.discount_type == undefined || this.table_tmp.discount_value == undefined) {
            this.table_tmp.discount_type = '';
            this.table_tmp.discount_value = 0;
        }


        //getIndexByTableuid
        await this.getIndexByTableuid();
        //recuperar amount
        var _amount = this.totalTicketSelected(this.selected_table_tpv_index);



        //create ticket
        this.afs.collection('tickets').add({
            UID_RESTAURANT: this.globals.restaurant_uid,
            amount: _amount,
            tax: this.globals.RESTAURANT_TAX,
            cash_static: this.table_tmp.cash_static,
            cash_uid: this.table_tmp.cash_uid,
            date: this.table_tmp.ticket.date,
            list: this.table_tmp.ticket.list,
            number: this.ticket_num_return,
            payment: true,
            payment_type: payment_type,
            waiter: this.table_tmp.ticket.waiter,
            waiter_uid: this.table_tmp.ticket.waiter_uid,
            type: type,
            closed: false,
            table_uid: this.table_tmp.UID,
            pending: false,
            discount_type: this.table_tmp.discount_type,
            discount_value: this.table_tmp.discount_value,
            tip: this.checkTip(this.table_tmp.ticket.tip),
            //customer: this.customer,
            customer_uid: this.customer.UID,
            delivery: this.tables_array[this.selected_table_tpv_index].ticket.delivery,
            delivery_notes: this.tables_array[this.selected_table_tpv_index].notes,
            datetime_pickup_delivey: this.tables_array[this.selected_table_tpv_index].datetime_pickup_delivey,
            order_state: this.globals.ifVarEmpty(this.tables_array[this.selected_table_tpv_index].ticket.order_state),
            persons: 1,

        }).then(value => {
            //Añadimos una coleccion dentro de tickets para guardar el cliente
            this.afs.collection('tickets/' + value.id + '/customer').add({
                'name': this.customer.name,
                'uid': this.customer.UID,
                'email': this.customer.email,
                'address': this.customer.address,
                'address_line2': this.customer.address_line2 || '',
                'business_name': this.customer.business_name,
                'business_number': this.customer.business_number,
                'note': this.customer.note,
                'phone': this.customer.phone,
            });
            //create format data for dataset
            var discount = false;
            if (this.table_tmp.discount_type != '') {
                discount = true;
            } else {
                discount = false;
            }
            var extra: any =
            {
                'ticket_open': moment(new Date(this.table_tmp.ticket.created_at.toDate())).format("YYYY/MM/DD HH:mm:ss").toString(),
                'ticket_close': moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString(),
                'persons': null,
                'room': 'Takeaway',
                'waiter': this.table_tmp.ticket.waiter,
                'discount': discount,
                'discount_type': this.table_tmp.discount_type,
                'discount_price': this.table_tmp.discount_value,
            };
            //dataset
            this.globals.dataSet('sales_ticket', _amount, '', JSON.stringify(extra), '');

            let elements = [];

            for (let element of this.globals.objectToArray(this.table_tmp.ticket.list)) {
                //comprobamos que el elemento no esté eliminado
                if (!element.delete) {
                    var _element = {
                        "name": element.name,//nom del producto/plato/menu
                        "uid_element": element.uid_element,//uid el producto/plato/menu
                        "sales": element.price,//precio 
                        "type": element.type,//que tipo de elemento es producto/plato/menu
                        "foodcost": 0,//foodcost
                        "waiter": element.waiter,
                        "half": "",
                    };
                    if (element.name.includes('<b> M.</b>')) {
                        _element.half = 'half'
                    } else if (element.name.includes('<b> P.</b>')) {
                        _element.half = 'tap'
                    }
                    elements.push(_element)
                }
            }
            var sales_elements = {
                "uid": this.globals.restaurant_uid,//uid_restaurant
                "uid_doc": value.id,//uid del ticket
                "date": new Date(),//date
                "list": elements,
                "type": "sales_elements",
            };
            var stock = {
                "elements": elements,
                "uid": this.globals.restaurant_uid,
                "date": new Date(),
                "type": "stock",
                "comment": "",
                "type_type": "TICKET",
                "delivery_uid": null
            };
            //insert _data
            this.analyticsServices.sendSalesElements(sales_elements);
            this.analyticsServices.sendStock(stock);
            //preparamos el objeto que enviaremos a sales_sales(_data)
            var sales_sales = {
                "uid": this.globals.restaurant_uid,//uid_restaurant
                "uid_doc": value.id,//uid del ticket
                "date": new Date(),//date
                "sales": _amount,//amount
                "type": "sales_sales",//el type para el switch de cloud funtions 
                "type_type": payment_type,//el tipo de pagamiento que an usado
                "persons": 1,//la cantidad de personas
                "zone": "Takeaway",//la room
                "discount_type": this.table_tmp.discount_type,//
                "discount": this.table_tmp.discount_value,//
                "foodcost": 0,//foodcost
                "tip": this.checkTip(this.table_tmp.ticket.tip),//tips
                'app_section': "tpv",//
                'text': this.ticket_num_return,
                'waiter': this.table_tmp.ticket.waiter
            };
            //insert _data
            this.analyticsServices.sendSalesSales(sales_sales);
            var sales_delivery = {
                "uid": this.globals.restaurant_uid,//uid_restaurant
                "uid_doc": value.id,//uid del ticket
                "date": new Date(),//date
                "sales": _amount,//amount
                "type": "sales_delivery",//el type para el switch de cloud funtions 
                "address": this.customer.address,//la address del users
                "delivery": this.tables_array[this.selected_table_tpv_index].ticket.delivery,//delivery utilizado
            };
            //insert _data
            this.analyticsServices.sendSalesDelivery(sales_delivery);
            //case payment_method_on_delivery (update mct_pay_charge)
            try {
                if (this.tables_array[this.selected_table_tpv_index].mct_pay_charge_state &&
                    this.tables_array[this.selected_table_tpv_index].mct_pay_charge_state === 'on_delivery' &&
                    this.tables_array[this.selected_table_tpv_index].mct_pay_charge_uid) {
                    this.updateMctPayCharge(
                        this.tables_array[this.selected_table_tpv_index],
                        {
                            payment: true,
                            payment_type: payment_type
                        },
                        value.id
                    );
                }
            } catch (error) { }
        });
        //getIndexByTableuid
        await this.getIndexByTableuid();
        //update table
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            ticket: this.tables_array[this.selected_table_tpv_index].ticket,
        });
    }

    updateMctPayCharge(table, payment_object, uid_ticket) {
        this.afs.collection('mct_pay_charge').doc(table.mct_pay_charge_uid).update({
            payment: payment_object.payment,
            payment_type: payment_object.payment_type,
            UID_TICKET: uid_ticket
        });
    }

    //Tickets
    ticketsCol: AngularFirestoreCollection<Ticket>;
    tickets: Observable<Ticket[]>;
    ticketDoc: AngularFirestoreDocument<Ticket>;
    ticket: any;
    ticket_num_return: any = -1;
    ticket_print = 'normal'; //normal - indv
    ticket_print_ind: any;
    ticket_print_ind_number: any;
    ticket_print_ind_date: any;

    //Funcion que busca el ultimo numero del ticket y hace update. Controla los numero por cajas y hace una serie diferente por caja
    async getTicketNumber(UID_RESTAURANT, cash_uid) {
        //getIndexByTableuid
        await this.getIndexByTableuid();
        //recuperar mesa
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        var _ticket_num_return = -1;
        //this.ticket_num_return = -1;//Reiniciamos el numero para encontrar el nuevo

        if (!this.table_tmp.ticket.number) {//Comprovamos si el ticket ya tiene un numero para no darle uno de nuevo
            var col = this.firestore.collection('cashs').doc(this.table_tmp.cash_uid);
            await col.get()
                .then(async doc => {
                    var doc = doc.data()
                    _ticket_num_return = doc.number + 1;
                    this.ticket_num_return = _ticket_num_return;
                    //getIndexByTableuid
                    await this.getIndexByTableuid();
                    //
                    this.tables_array[this.selected_table_tpv_index].ticket.number = _ticket_num_return;
                    this.cashUpdateNumber(this.table_tmp.cash_uid, _ticket_num_return);
                    this.updateTableNumber(_ticket_num_return);
                });
            /*
            this.cashs_array.forEach(value => {
    
                if (value.UID == cash_uid) {
                    _ticket_num_return = value.number + 1;
                    this.ticket_num_return = _ticket_num_return;
                    this.updateTableNumber(_ticket_num_return);
                    this.cashUpdateNumber(value.UID, _ticket_num_return);
                }
            });*/
        } else {
            this.ticket_num_return = this.table_tmp.ticket.number;
        }
        return true;

    }

    //Menus
    menusCol: AngularFirestoreCollection<Menu>;
    menus: Observable<Menu[]>;
    combosCol: AngularFirestoreCollection<Menu>;
    combos: Observable<Menu[]>;
    menusDoc: AngularFirestoreDocument<Menu>;
    menu: any;
    favourite_menus: Observable<Menu[]>;
    favourite_menus_count: number = 0;

    getMenus(UID_RESTAURANT) {
        this.menusCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('type', '==', 'menu')
            .orderBy('title_es', 'asc'));
        this.menus = this.menusCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Menu;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
        });
    }

    getCombos(UID_RESTAURANT) {
        this.combosCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('type', '==', 'combo')
            .orderBy('title_es', 'asc'));
        this.combos = this.combosCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Menu;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
        });
    }

    getFavouriteMenus(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.menusCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy('title_es', 'asc'));
            this.favourite_menus = this.menusCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Menu;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
            //
            this.menusCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Menu;
                    data.UID = a.payload.doc.id;
                    this.favourite_menus_count++;
                });
            });
        }
    }

    //Dish
    dishsCol: AngularFirestoreCollection<Dish>;
    dishs: Observable<Dish[]>;
    dishsDoc: AngularFirestoreDocument<Dish>;
    dish: any;
    dish_tags: any = Array();
    favourite_dishs: Observable<Dish[]>;
    favourite_dishs_count: number = 0;

    getDish(UID_RESTAURANT) {
        this.dishsCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy(this.globals.returnLangTag('dish'), 'asc'));
        this.dishs = this.dishsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Dish;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
        });

        //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
        this.dishsCol.snapshotChanges().subscribe(value => {
            value.map(a => {
                const data = a.payload.doc.data() as Dish;
                data.UID = a.payload.doc.id;
                if (data.tags) {
                    data.tags.forEach(value => {//Insert to array all dish tags
                        this.dish_tags.push(value.toLowerCase());
                        return value;
                    });
                }


                return data;
            });
            this.dish_tags = this.cleanDuplicates(this.dish_tags);//Clean duplicates dish tags to the array
            this.dish_tags = this.globals.orderNamesByAlphabetical(this.dish_tags);//order alphabetic
        });
    }

    getFavouriteDishes(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.dishsCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy(this.globals.returnLangTag('dish'), 'asc'));
            this.favourite_dishs = this.dishsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Dish;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });

            //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
            this.dishsCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Dish;
                    data.UID = a.payload.doc.id;
                    this.favourite_dishs_count++;
                });
            });
        }
    }

    /*Send tag selected between components*/
    private subject = new Subject<any>();

    sendTagDish(message: string) {
        this.subject.next({ message });
    }

    getTagDish(): Observable<any> {
        return this.subject.asObservable();
    }

    //Products
    productsCol: AngularFirestoreCollection<Product>;
    products: Observable<Product[]>;
    productsDoc: AngularFirestoreDocument<Product>;
    product: any;
    products_tags: any = Array();
    favourite_products: Observable<Product[]>;
    favourite_products_count: number = 0;

    getProducts(UID_RESTAURANT) {
        this.productsCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy(this.globals.returnLangTag('product'), 'asc'));
        this.products = this.productsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Product;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectProduct(a).localeCompare(this.globals.nameLangSelectProduct(b)));
        });

        //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
        this.productsCol.snapshotChanges().subscribe(value => {
            value.map(a => {
                const data = a.payload.doc.data() as Product;
                data.UID = a.payload.doc.id;
                if (data.tags) {
                    data.tags.forEach(value => {//Insert to array all dish tags
                        this.products_tags.push(value.toLowerCase());
                        return value;
                    });
                }
                return data;
            });
            this.products_tags = this.cleanDuplicates(this.products_tags);//Clean duplicates dish tags to the array
            this.products_tags = this.globals.orderNamesByAlphabetical(this.products_tags);//order alphabetic
        });
    }

    getFavouriteProducts(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.productsCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy(this.globals.returnLangTag('product'), 'asc'));
            this.favourite_products = this.productsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Product;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });

            //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
            this.productsCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Product;
                    data.UID = a.payload.doc.id;
                    this.favourite_products_count++;
                });
            });
        }
    }


    /*Send tag selected between components*/
    private subjectProduct = new Subject<any>();

    sendTagProduct(message: string) {
        this.subjectProduct.next({ message });
    }

    getTagProduct(): Observable<any> {
        return this.subjectProduct.asObservable();
    }

    //Cash
    cashsCol: AngularFirestoreCollection<Cash>;
    cashs: Observable<Cash[]>;
    cashsDoc: AngularFirestoreDocument<Cash>;
    cash: any;
    cashs_array = [];

    getCashs(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'multi_cash')) {
            this.cashsCol = this.afs.collection('cashs', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('number', 'desc'));
            this.cashs = this.cashsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Cash;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
        } else {
            this.cashsCol = this.afs.collection('cashs', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('number', 'desc').limit(1));
            this.cashs = this.cashsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Cash;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
        }

        this.cashsCol.snapshotChanges().subscribe(value => {
            this.cashs_array = [];
            value.map(a => {
                const data = a.payload.doc.data() as Cash;
                data.UID = a.payload.doc.id;
                this.cashs_array.push(data);

                return data;
            });

        });

    }

    getCashNumber() {
        this.cashs_array.forEach(value => {
        });


    }

    async cashUpdateNumber(uid, number) {
        //Actualizamos la tabla de la base de datos
        this.afs.collection('cashs').doc(uid).update({
            number: number,
        });
    }

    async getCash(cash_uid) {
        const cashRef = this.firestore.collection('cashs').doc(cash_uid);

        var _cash;

        await
            cashRef.get().then(doc => {
                _cash = doc.data();
                _cash.UID = doc.id;
            });

        return _cash
    }


    //Keyboard
    public keyboard_screen: string = '';
    public keyboard_blockscreen: string = '';

    insertKeyboard(number) {
        this.keyboard_screen = this.keyboard_screen + '' + number;
    }

    deleteKeyboard() {
        this.keyboard_screen = '';
    }

    insertKeyboardBlockscreen(number) {
        this.keyboard_blockscreen = this.keyboard_blockscreen + '' + number;
    }

    deleteKeyboardBlockscreen() {
        this.keyboard_blockscreen = '';
    }

    //Help
    cleanDuplicates(arr) {
        var unique = arr.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
        });
        return unique;
    }

    async getOrdersF(UID_RESTAURANT, table_uid) {

        const ordersRef = this.firestore.collection('orders');

        var orders = [];

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var order = doc.data();
                    order.UID = doc.id;

                    orders.push(order);
                });
            });

        return orders
    }

    async getOrdersAllPrint(UID_RESTAURANT, table_uid) {
        this.listall_print = [];

        const ordersRef = this.firestore.collection('orders');

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var order = doc.data();
                    order.UID = doc.id;

                    this.listall_print.push(order);
                });
            });
    }

    async getOrdersLastPrint(UID_RESTAURANT, table_uid) {
        this.listchange_print = [];
        var _listchange_print = [];

        const ordersRef = this.firestore.collection('orders');

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var order = doc.data();
                    order.UID = doc.id;

                    _listchange_print.push(order);
                });
            });
        this.listchange_print.push(_listchange_print[0]);
    }




    ordersCol: AngularFirestoreCollection<Order>;
    orders: Observable<Order[]>;
    orderDoc: AngularFirestoreDocument<Order>;

    getOrders(UID_RESTAURANT, table_uid) {
        this.ordersCol = this.afs.collection('orders', ref => ref
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid));
        this.orders = this.ordersCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Order;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

    async deleteOders(UID_RESTAURANT, table_uid) {
        var jobskill_query = this.firestore.collection('orders')
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid);
        jobskill_query.get().then(snapshot => {
            snapshot.forEach(doc => {
                var order = doc.data();
                order.UID = doc.id;

                for (let section of order.sections) {
                    for (let list of section.list) {
                        list.state = 'delete';
                    }
                }
                this.firestore.collection('orders').doc(order.UID).update({
                    show_order: false,
                    sections: order.sections
                });
            });
        });
    }

    changeState(state) {
        this.orders_print = state;
        var _state = state;
        return _state;
    }


    async getAccessCodes() {

        const ordersRef = this.firestore.collection('users');

        var users = [];

        await ordersRef.get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var user = doc.data();
                    user.UID = doc.id;
                    users.push(user);
                });
            });

        return users
    }

    checkTip(quantity) {
        var tip_amount = 0;
        if (quantity) {
            tip_amount = quantity;
        }
        return tip_amount;
    }

    cleanVariables() {
        this.order_tmp = [];
        this.section_order = this.translate.instant('general-todos');
        this.section_menu_order = this.translate.instant('general-primeros');
        this.menu_select = '';
    }

    async getCustomer(customer_uid) {
        var customer_finded = false;

        if (customer_uid) {
            const customersRef = this.firestore.collection('customers').doc(customer_uid);

            await customersRef.get().then(doc => {
                if (doc.data()) {
                    var data = doc.data();
                    data.UID = doc.id;
                    this.customer = data;
                    customer_finded = true;
                } else {
                    customer_finded = false;
                    this.customer = {};
                }

            });
        } else {
            customer_finded = false;
            this.customer = {};
        }

        return customer_finded;
    }

    async getDeliveries() {
        const deliveryRef = this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries');

        await deliveryRef.get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    const delivery = doc.data();
                    delivery.UID = doc.id;
                    var finded = this.deliveries.find(item => item.UID === delivery.UID);
                    if (finded == undefined) {
                        this.deliveries.push(delivery);
                    }
                });
            });
    }

    getDeliveriesFavorites() {

        var _active = false
        //Recorremos todo el listado de deliveries del restaurante
        this.deliveries.forEach(delivery => {
            _active = false
            //Miramos si el delivery está seleccionado
            for (let active_delivery of this.configurationServices.selects_deliveries) {
                if (delivery.name == active_delivery.name) {
                    _active = true;
                    delivery.favorites_UID = active_delivery.UID;
                    break;
                }
            };
            delivery.active = _active;

        });

    }

    async getIndexByTableuid() {
        var index = this.tables_array.findIndex(table => table.UID == this.selected_table_uid);
        if (index >= 0) {
            this.selected_table_tpv_index = index;
        } else {
            this.selected_table_tpv_index = undefined;
        }
    }

    async getHorary() {
        this.horary_array = [];
        //recuperamos la informacion necesaria
        var new_date = new Date();

        var open_hour
        var close_hour
        var hour_interval

        if (this.globals.restaurant.web_tk_open_hour == undefined || this.globals.restaurant.web_tk_close_hour == undefined || this.globals.restaurant.interval_between_orders == undefined || this.globals.restaurant.number_orders == undefined) {
            //hora de inicio
            open_hour = "12:00";
            //hora de cierre
            close_hour = "24:00";
            //intervalo entre pedidos
            hour_interval = 60;

            this.config_horary = false;
        } else {
            //hora de inicio
            open_hour = this.globals.restaurant.web_tk_open_hour;
            //hora de cierre
            close_hour = this.globals.restaurant.web_tk_close_hour;
            //intervalo entre pedidos
            hour_interval = this.globals.restaurant.interval_between_orders;

            this.config_horary = true;

        }

        //date de fecha inicio
        var start = new Date(new_date.getFullYear(), new_date.getMonth(), new_date.getDate(), open_hour.split(":", 1).pop(), open_hour.split(":").pop(), 0);
        //date de fecha cierre
        var end = new Date(new_date.getFullYear(), new_date.getMonth(), new_date.getDate(), close_hour.split(":", 1).pop(), close_hour.split(":").pop(), 0);

        var active_hour = false;
        //creamos las franjas horarias
        for (start; start < end; start = moment(start).add(hour_interval, 'm').toDate()) {
            active_hour = false

            if (start < new_date && moment(start).add(hour_interval, 'm').toDate() > new_date) {
                active_hour = true
            }
            this.horary_array.push({ uid: start.getHours() + start.getMinutes(), hour_start: start, hour_end: moment(start).add(hour_interval, 'm').toDate(), orders: [], current_time: active_hour });
        }

        //recorremos los tk para asignarlos a la franja pertinente
        if (this.tables_array != undefined) {
            if (this.tables_array.length > 0) {
                this.tables_array.forEach(table => {
                    if (table.datetime_pickup_delivey != undefined) {
                        table.delivery_time = new Date(this.globals.timestampToDate(table.datetime_pickup_delivey));
                    } else {
                        table.delivery_time = "";
                    }
                    this.horary_array.forEach(hour => {
                        if (hour.hour_start <= table.delivery_time && hour.hour_end > table.delivery_time && (table.show_takeaway == undefined || table.show_takeaway == true)) {
                            hour.orders.push(table);
                        }

                    });
                });
            }
        }
        //recorremos las mesas para asignarlas a la franja pertinente
        this.tpvServices.tables_array.forEach(table => {
            if (table.ticket.updated_at != undefined) {
                table.delivery_time = new Date(this.globals.timestampToDate(table.ticket.updated_at));
            } else {
                table.delivery_time = "";
            }
            this.horary_array.forEach(hour => {
                if (hour.hour_start <= table.delivery_time && hour.hour_end > table.delivery_time && table.type != "takeaway" && table.state != "open") {
                    hour.orders.push(table);
                }
            });
        });
    }

    sumAmount(ticket) {
        //calcular el amount
        var total = 0;
        for (let key in ticket.list) {
            let value = ticket.list[key];
            if (value.count && !value.delete) {
                total += parseFloat(value.price); //Sumamos el precio del plato
                //Variations
                if (value.variation) {
                    for (let key2 in value.variation) {
                        let variation = value.variation[key2];
                        total += parseFloat(variation.price);
                    }
                }
            }
        }

        if (ticket.tip) {
            //total += this.globals.createTotal(ticket.tip, this.globals.user_tax);
            total += ticket.tip;
        }
        return total;
    }

    countUnits(ticket) {
        var count = 0;
        if (ticket.list) {//miramos que tenga lista
            count = this.globals.objectToArray(ticket.list).length;
        }
        return count;
    }

    async getTakeawayTables2Delete(UID_RESTAURANT) {
        var tables_array_take_away = [];

        const ordersRef = this.firestore.collection('tables');

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('type', '==', 'takeaway')
            .orderBy('created_at', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var table = doc.data();
                    table.UID = doc.id;
                    table.active_delete = false;

                    tables_array_take_away.push(table);
                });
            });
        return tables_array_take_away;
    }

    async getTakeawayTickets2Recover(UID_RESTAURANT, date_first, date_last) {
        const ticketsRef = this.firestore.collection('tickets');
        var tickets = [];

        await ticketsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('payment', '==', true)
            .where('type', '==', 'takeaway')
            .where('date', '>', new Date(this.globals.replaceChar(date_first, 'T')))
            .where('date', '<', new Date(this.globals.replaceChar(date_last, 'T')))
            .orderBy('date', 'desc')
            .get()
            .then(snapshot => {
                snapshot.forEach(async doc => {
                    var ticket = doc.data();
                    ticket.UID = doc.id;
                    ticket.active_recover = false;
                    ticket.customer = await this.getCustomerFromSubCollection(doc.id);
                    tickets.push(ticket);
                });
            });

        return tickets;
    }

    async getCustomerFromSubCollection(ticket_doc) {
        var customer = [];
        const ticketsRef = this.firestore.collection('tickets').doc(ticket_doc).collection('customer');

        await ticketsRef
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var _doc = doc.data();
                    _doc.UID = doc.id;
                    customer = _doc;
                });
            });

        return customer;
    }

    async getOrdersfs(UID_RESTAURANT, uid_table) {
        const OrdersRef = this.firestore.collection('orders');
        var orders = [];

        await OrdersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('table_uid', '==', uid_table)
            .get()
            .then(snapshot => {
                snapshot.forEach(async doc => {
                    var order = doc.data();
                    order.UID = doc.id;
                    orders.push(order);
                });
            });

        return orders;
    }

    checkOldOrders() {
        var today = new Date()
        this.old_orders = [];
        today.setHours(0, 0, 0, 0);
        this.alert_old_orders = false;
        //
        var order_arry = [];
        order_arry = this.tables_array;


        for (let order of order_arry) {
            if (order.datetime_pickup_delivey == "") {
                if ((new Date(this.globals.timestampToDate(order.created_at)) < today)) {
                    this.old_orders.push(order.UID);
                    this.alert_old_orders = true;
                }
            } else {
                if ((new Date(this.globals.timestampToDate(order.datetime_pickup_delivey)) < today)) {
                    this.old_orders.push(order.UID);
                    this.alert_old_orders = true;
                }
            }
        }
    }

    getCodeDeliverect(status) {
        switch (status) {
            case 'stateless': {
                //PARSED
                return 1;
            }
            case 'received': {
                //RECEIVED;
                return 2
            }
            case 'accepted': {
                //ACCEPTED;
                return 20
            }
            case 'kitchen': {
                //PREPARING;
                return 50
            }
            case 'ready_for_pickup': {
                //READY FOR PICKUP;
                return 70
            }
            case 'sent': {
                //IN DELIVERY;
                return 70
            }
            case 'delayed_15': {
                //DELAYED 15;
                return 70
            }
            case 'delayed_30': {
                //DELAYED 30;
                return 70
            }
            case 'cancelled': {
                //CANCELLED;
                return 110
            }
            case 'prepared': {
                //PREPARED;
                return 60
            }
            case 'completed': {
                //FINALIZED;
                return 90
            }
            case 'failed': {
                //FINALIZED;
                return 120
            }
            default: {
                return 20;
            }
        }
    }

    getStateDeliverect(status) {
        switch (status) {
            case 1: {
                //PARSED
                return 'stateless';
            }
            case 2: {
                //RECEIVED;
                return 'received'
            }
            case 20: {
                //ACCEPTED;
                return 'accepted'
            }
            case 50: {
                //PREPARING;
                return 'kitchen'
            }
            case 70: {
                //READY FOR PICKUP;
                return 'ready_for_pickup'
            }
            case 80: {
                //IN DELIVERY;
                return 'sent'
            }
            case 110: {
                //CANCELLED;
                return 'cancelled'
            }
            case 60: {
                //PREPARED;
                return 'prepared'
            }
            case 90: {
                //FINALIZED;
                return 'completed'
            }
            case 120: {
                //FINALIZED;
                return 'failed'
            }
            default: {
                return 'payment_completed';
            }
        }
    }

    formatState(status) {
        switch (status) {
            case 'stateless': {
                return this.translate.instant('tk-state-stateless');
            }
            case 'received': {
                return this.translate.instant('tk-state-received');
            }
            case 'accepted': {
                return this.translate.instant('tk-state-accepted');
            }
            case 'payment_completed': {
                return this.translate.instant('tk-state-payment-completed');
            }
            case 'kitchen': {
                return this.translate.instant('tk-state-kitchen');
            }
            case 'ready_for_pickup': {
                return this.translate.instant('tk-state-ready-for-pickup');
            }
            case 'prepared': {
                return this.translate.instant('tk-state-prepared');
            }
            case 'sent': {
                return this.translate.instant('tk-state-sent');
            }
            case 'delayed_15': {
                return this.translate.instant('tk-state-delayed-15');
            }
            case 'delayed_30': {
                return this.translate.instant('tk-state-delayed-30');
            }
            case 'completed': {
                return this.translate.instant('tk-state-completed');
            }
            case 'cancelled': {
                return this.translate.instant('tk-state-cancelled');
            }
            case 'failed': {
                return this.translate.instant('tk-state-failed');
            }
            default: {
                return this.translate.instant('tk-state-stateless');
            }
        }
    }

    async checkDeliverectCancelled(table) {
        //comprobamos que el estado del pedido de deliverect no este en cancel (100)
        if (table.deliverect_order_state != undefined && table.deliverect_order_state != undefined) {
            if (table.deliverect_order_state == 100) {

                table.deliverect_order_state = 110;
                table.order_state = 'cancelled';

                //Si este cancel deliverect nos manda modificar el estado a canceled (110)
                //en cuyo caso lo actualizaremos tanto en el ticket como en la table
                await this.http.post(this.globals.analytics_path + 'deliverect_update_status', {
                    orderid: table.deliverect_order_id,
                    status: 110,
                    uid_restaurant: table.UID_RESTAURANT
                }, {}).subscribe(async data => {
                },
                    err => {
                    }
                );

                this.afs.collection('tables').doc(table.UID).update({
                    'deliverect_order_state': 110,
                    'order_state': 'cancelled',
                });

                var ticket_uid
                //Recuperamos la uid del ticket
                await this.firestore.collection('tickets')
                    .where('UID_RESTAURANT', '==', table.UID_RESTAURANT)
                    .where('number', '==', table.ticket.number)
                    .where('cash_uid', '==', table.cash_uid)
                    .get()
                    .then(snapshot => {
                        snapshot.forEach(doc => {
                            ticket_uid = doc.id;
                        });
                        this.afs.collection('tickets').doc(ticket_uid).update({
                            'deliverect_order_state': 110,
                            'order_state': 'cancelled'
                        });
                    });
            }
        }
    }

    checkIfTablePaid() {
        //
        if (this.selected_table_tpv_index != undefined) {
            //
            if (this.selected_table_tpv_index >= 0 && this.globals.side_menu_active == 'tpv') {
                //
                if (this.tables_array[this.selected_table_tpv_index] != undefined) {
                    //
                    if (this.tables_array[this.selected_table_tpv_index].payment && this.tables_array[this.selected_table_tpv_index].payment_source != '' && !this.globals.table_paid_alert) {
                        //
                        this.globals.launchAlertTablePaid(this.tables_array[this.selected_table_tpv_index], 'tk');
                    }
                }
            }
        }
    }

    checkGirona() {
        //Comprovamos los UID de los restaurantes para saber si es del Girona
        if (this.globals.restaurant_uid == '9LXypA7YjaMswTPfVg1g'
            || this.globals.restaurant_uid == 'KODznOlh7l9b7vblbOuR'
            || this.globals.restaurant_uid == '9Asns3zTW0T0Cc5PJgLu'
            || this.globals.restaurant_uid == 'E7CYyj30xc0PDLJ111Bj'
            || this.globals.restaurant_uid == 'nNgd4t9C63xdYZZ2Ql0H'
            || this.globals.restaurant_uid == 'TczbaMYn0zvpGpGkLvrj'
            || this.globals.restaurant_uid == 'dchoFpUJRkRgMOJCdkUK'
            || this.globals.restaurant_uid == 'eIpuaSl0PXln3EGEedpa'
            || this.globals.restaurant_uid == '8DHNvP8l5sXGBDeEbe4H'
            || this.globals.restaurant_uid == 'Z72lb9K7l4aWLtj69ID8') {
            this.is_girona = true;
        }
    }



    totalTicketSelectedTable(table) {
        var _taxs = this.globals.showIvaProducts(table.ticket.list);
        return _taxs.total
    }

    getDeliveryImage(table) {
        if (table != undefined) {
            const delivery = this.deliveries.find(t => t.name == table);
            if (delivery != undefined) {
                return delivery.img;
            }
        }
    }

    sendEmailOrderState(table, name_state, customer_email, customer_name, customer_phone, customer_address) {
        var table_key = this.globals.generateOrderCode(table.UID);
        //tener en cuenta que el email y otros datos si viene de deliverecto no son el customer_name y etc
        this.firestore.collection('_emails').add({
            'UID_RESTAURANT': table.UID_RESTAURANT,
            'type': 'order_state',
            'customer_name': customer_name,
            'customer_email': customer_email,
            'customer_phone': customer_phone,
            'takeaway_type': table.type,
            'ticket_number': table.ticket.number,
            'ticket_list': table.ticket.list,
            'ticket_date': this.globals.timestampToDate(table.ticket.date),
            'ticket_currency': getCurrencySymbol(this.globals.user_currency, 'narrow', 'es'),
            'ticket_subtotal': this.sumAmount(table.ticket) / ((this.globals.RESTAURANT_TAX + 100) / 100),
            'ticket_total': this.sumAmount(table.ticket),
            'ticket_tax_name': this.globals.user_tax_name,
            'ticket_tax': this.globals.RESTAURANT_TAX,
            'restaurant_company': this.globals.restaurant.company,
            'restaurant_address': this.globals.restaurant.address,
            'restaurant_email': this.globals.restaurant.email,
            'restaurant_phone': this.globals.restaurant.phone,
            'restaurant_logo': this.globals.getRestaurantLogoUrl(this.globals.restaurant.logo),
            'order_status': name_state,
            'table_key': table_key,
            'address': customer_address,
            'table_uid': table.UID
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/takeaway/services.ts